import React, { useEffect, useState } from 'react'

import styles from './_gradient-container.module.scss'

export type GradientContainerProps = {
  children: React.ReactNode
  containerHeight: number
  containerScrollHeight: number
}

const GradientContainer = ({
  children,
  containerHeight,
  containerScrollHeight,
}: GradientContainerProps): React.JSX.Element => {
  const [showGradients, setShowGradients] = useState(false)

  useEffect(() => {
    if (typeof containerHeight === 'number') {
      setShowGradients(containerScrollHeight > containerHeight)
    }
  }, [containerHeight, containerScrollHeight])

  return (
    <div>
      {showGradients ? <div className={styles.topGradient} /> : null}
      {children}
      {showGradients ? <div className={styles.bottomGradient} /> : null}
    </div>
  )
}

export default GradientContainer
